export default "__VITE_ASSET__BdBEe3T$__"